/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

const tStoreJanePrinter = t.type({
  id: t.string,
  store_id: t.number,
  store_name: t.string,
  jane_printer_id: t.string,
});

export const tJanePrinter = t.type({
  id: t.string,
  name: t.union([t.string, t.null]),
  enabled: t.boolean,
  mac_address: t.union([t.string, t.null]),
  delivery_order_checked_out: t.boolean,
  pickup_order_checked_out: t.boolean,
  curbside_order_checked_out: t.boolean,
  kiosk_order_checked_out: t.boolean,
  curbside_arrived: t.boolean,
  store_jane_printers: t.array(tStoreJanePrinter),
  username: t.string,
  number_of_queued_jobs: t.number,
});

export const tCloudPrinterSetting = t.union([
  t.null,
  t.type({
    store_id: t.number,
    store_description: t.union([t.null, t.string]),
    print_store_name: t.boolean,
    print_date_of_birth: t.boolean,
    print_medical_id_number: t.boolean,
    print_fulfillment_type: t.boolean,
    print_pos_identifier: t.boolean,
    print_pos_product_name: t.boolean,
    print_items_grouped_by_kind: t.boolean,
    auto_print_dismissed_orders: t.boolean,
  }),
]);
export type CloudPrinterSetting = t.TypeOf<typeof tCloudPrinterSetting>;
